import { useEffect, useState } from 'react';

import { NewsAndEventsModel } from '../interface/news-and-events';

export const useNewsAndEventsFilter = (
  newsAndEventsContent: NewsAndEventsModel[],
  article_type: string
) => {
  const [selectedYear, setSelectedYear] = useState('');
  const [filteredNewsAndEventsContent, setFilteredNewsAndEventsContent] =
    useState(newsAndEventsContent);

  useEffect(() => {
    const getNewsAndEventsDataByYear = async () => {
      const newsAndEventsData = await fetch(
        `/api/news?year=${selectedYear}&article_type=${article_type}`
      );
      const attributes =
        (await newsAndEventsData.json()) as NewsAndEventsModel[];

      setFilteredNewsAndEventsContent(attributes);
    };
    getNewsAndEventsDataByYear();
  }, [selectedYear]);

  function handleClickYear(year: string) {
    setSelectedYear(year);
  }

  return {
    filteredNewsAndEventsContent,
    selectedYear,
    handleClickYear
  };
};
